import Vue from "vue";
import { publicPath } from "../../vue.config.js";
import VueRouter from "vue-router";
import Error from "@/views/Error.vue";
import UpdateRequest from "@/views/UpdateRequest";
import UpdateCheck from "@/views/UpdateCheck";
import CheckplusSuccess from "@/components/certification/CheckplusSuccess";
import CheckplusFail from "@/components/certification/CheckplusFail";

import Expired from "@/views/Expired";
import { PAGE_NAME } from "@/constant.js";
import store from "@/store/index";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: publicPath,
  routes: [
    { path: PAGE_NAME.PN_UPR, component: UpdateRequest },
    { path: PAGE_NAME.PN_UPC, component: UpdateCheck },
    { path: PAGE_NAME.PN_CPS, component: CheckplusSuccess },
    { path: PAGE_NAME.PN_CPF, component: CheckplusFail },
    { path: PAGE_NAME.PN_ERR, component: Error },
    { path: PAGE_NAME.PN_EXP, component: Expired },

    { path: "/", component: UpdateRequest },

    { path: "*", redirect: PAGE_NAME.PN_ERR, hidden: true },
  ],
});

// REMOVE: no-unused-vars 회피용
console.log(store);

export default router;
